"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _DocumentViewer = _interopRequireDefault(require("../DocumentViewer"));

var _SignatureTOSDialog = _interopRequireDefault(require("./SignatureTOSDialog"));

var _ClickThroughAcknowledgment = _interopRequireDefault(require("./ClickThroughAcknowledgment"));

var _GrowlNotification = _interopRequireDefault(require("./GrowlNotification"));

var _DocumentSelector = _interopRequireDefault(require("./DocumentSelector"));

var _ActionButtons = _interopRequireDefault(require("./ActionButtons"));

var _SaveSignature = _interopRequireDefault(require("./SaveSignature"));

var FieldStore = _interopRequireWildcard(require("./Fields"));

var _theme = require("../shared/oldDocumentSignerUI/theme");

var FieldTypes = _interopRequireWildcard(require("../utilities/constants/fieldTypes"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _decorateDocuments = _interopRequireDefault(require("./decorateDocuments"));

var _inViewport = _interopRequireDefault(require("in-viewport"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AUTOSAVE_INTERVAL = 10000;

var styles = function styles(theme) {
  return {
    root: {
      display: 'grid',
      gridTemplateRows: '100%',
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      backgroundColor: '#f2f5f7',
      gridTemplateColumns: '20% 1fr',
      gridTemplateAreas: "\"documentSelector documentViewer\""
    },
    documentSelector: {
      gridArea: 'documentSelector'
    },
    documentViewer: {
      gridArea: 'documentViewer'
    },
    busyOverlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(195, 195, 195, 0.8)',
      zIndex: 100000,
      display: 'grid',
      placeContent: 'center'
    },
    busyContainer: {
      textAlign: 'center'
    }
  };
};

var DocumentSigner = /*#__PURE__*/function (_Component) {
  _inherits(DocumentSigner, _Component);

  function DocumentSigner(_props) {
    var _this;

    _classCallCheck(this, DocumentSigner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DocumentSigner).call(this, _props)); // Get decorated documents

    _defineProperty(_assertThisInitialized(_this), "cleanUpNotification", function () {
      _this.setState({
        growlType: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideNotification", function (event, reason) {
      if (reason === 'clickaway') return;

      _this.setState({
        growlOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNotificationContinue", function (nextDocId) {
      return function () {
        _this.setState({
          growlOpen: false
        });

        _this.setCurrentDocument(nextDocId);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "notifyIfDocumentComplete", function (doc) {
      var fields = doc.fields,
          _doc$_derived = doc._derived,
          isComplete = _doc$_derived.isComplete,
          docError = _doc$_derived.error;

      var _this$getDocumentPosi = _this.getDocumentPosition({
        filterOutCompleted: true
      }),
          nextDocId = _this$getDocumentPosi.nextDocId;

      var docFieldError = fields.some(function (f) {
        return f._derived.error;
      });
      var canContinue = isComplete && nextDocId && !docError && !docFieldError;

      if (canContinue) {
        _this.setState({
          growlType: 'documentComplete',
          growlOpen: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "autosave", (0, _lodash.default)(function (doc) {
      var _this$props$actions = _this.props.actions,
          actions = _this$props$actions === void 0 ? {} : _this$props$actions;

      var _ref = actions || {},
          _ref$save = _ref.save,
          save = _ref$save === void 0 ? {} : _ref$save;

      var _ref2 = save || {},
          saveAction = _ref2.action;

      if (!saveAction) {
        console.warn('Attempted to perform save action but no function was passed down.');
        return;
      }

      saveAction([doc], true); // Flag indicates this is an autosave
    }, AUTOSAVE_INTERVAL));

    _defineProperty(_assertThisInitialized(_this), "onDocumentDidChange", function () {
      var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.getCurrentDocument();

      _this.autosave(doc);

      _this.notifyIfDocumentComplete(doc);
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeFieldValue", function (documentId, fieldId, value) {
      var errors = _this.state.errors;
      var fieldToFocus;

      _this.setState(function (_ref3) {
        var documents = _ref3.documents;
        var doc = documents.find(function (_ref4) {
          var id = _ref4.id;
          return id === documentId;
        });

        var _ref5 = doc || {},
            _ref5$fields = _ref5.fields,
            fields = _ref5$fields === void 0 ? [] : _ref5$fields;

        var field = fields.find(function (_ref6) {
          var id = _ref6.id;
          return id === fieldId;
        });

        var newField = _objectSpread({}, field, {
          value: value
        });

        var newDocument = _objectSpread({}, doc, {
          fields: fields.map(function (field) {
            return field.id === fieldId ? newField : field;
          })
        });

        var newDocuments = (0, _decorateDocuments.default)(documents.map(function (doc) {
          return doc.id === documentId ? newDocument : doc;
        }), errors, fieldId);
        var maxLength = field.max;

        if (maxLength && "".concat(value).length === maxLength) {
          var fieldIndex = fields.findIndex(function (_ref7) {
            var id = _ref7.id;
            return id === fieldId;
          });
          fieldToFocus = fields[fieldIndex + 1];
        }

        return {
          documents: newDocuments
        };
      }, function () {
        if (fieldToFocus) {
          var _fieldToFocus = fieldToFocus,
              fieldType = _fieldToFocus._derived.fieldType;

          if (fieldType === FieldTypes.TXT || fieldType === FieldTypes.NUMBER) {
            _this.goToField(fieldToFocus.id);
          }
        }

        var documents = _this.state.documents;
        var doc = documents.find(function (_ref8) {
          var id = _ref8.id;
          return id === documentId;
        });

        _this.onDocumentDidChange(doc);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAcknowledgmentClosed", function (closed) {
      _this.setState(function (_ref9) {
        var modals = _ref9.modals;
        return {
          modals: _objectSpread({}, modals, {
            acknowledgment: {
              closed: closed
            }
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeSignatureTOSDialog", function () {
      // This gets called when someone presses the close icon
      // in the signature tos dialog
      // We close the modal and clear the field type and id
      _this.setState(function (_ref10) {
        var modals = _ref10.modals;
        return {
          modals: _objectSpread({}, modals, {
            signature: {
              open: false,
              field: null
            }
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "acceptSignatureTOS", function (fieldValue) {
      var _this$state = _this.state,
          currentDocumentId = _this$state.currentDocumentId,
          field = _this$state.modals.signature.field;
      var fieldId = field.id,
          _field$_derived = field._derived,
          isSignature = _field$_derived.isSignature,
          fieldType = _field$_derived.fieldType;

      if (!isSignature) {
        console.warn('Attempted to accept Signature ToS on a non signature field.');
        return;
      } // Update the state and accept the signature tos
      // Close the modal, and then hand it off to onChangeFieldValue


      _this.setState(function (_ref11) {
        var modals = _ref11.modals,
            signedFieldTypes = _ref11.signedFieldTypes;
        return {
          signedFieldTypes: _objectSpread({}, signedFieldTypes, _defineProperty({}, fieldType, true)),
          modals: _objectSpread({}, modals, {
            signature: {
              open: false,
              field: null
            }
          })
        };
      }, function () {
        return _this.onChangeFieldValue(currentDocumentId, fieldId, fieldValue);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "shouldAutosign", function (field) {
      var _this$state2 = _this.state,
          isSignatureSaved = _this$state2.isSignatureSaved,
          signedFieldTypes = _this$state2.signedFieldTypes;
      var _field$_derived2 = field._derived,
          isSignature = _field$_derived2.isSignature,
          isValidated = _field$_derived2.isValidated,
          fieldType = _field$_derived2.fieldType;
      var isTosAccepted = !!signedFieldTypes[fieldType];
      return isSignature && isValidated && (isTosAccepted || isSignatureSaved);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSignatureButtonClick", function (fieldId) {
      var _this$props$actor = _this.props.actor,
          actor = _this$props$actor === void 0 ? {} : _this$props$actor;

      var _ref12 = actor || {},
          name = _ref12.name,
          initials = _ref12.initials;

      var _this$getCurrentDocum = _this.getCurrentDocument(),
          _this$getCurrentDocum2 = _this$getCurrentDocum.fields,
          fields = _this$getCurrentDocum2 === void 0 ? [] : _this$getCurrentDocum2,
          documentId = _this$getCurrentDocum.id;

      var field = fields.find(function (_ref13) {
        var id = _ref13.id;
        return id === fieldId;
      });
      var _field$_derived3 = field._derived,
          isInitials = _field$_derived3.isInitials,
          isSignature = _field$_derived3.isSignature,
          fieldType = _field$_derived3.fieldType; // Make sure we are only executing on a signature field

      if (!isSignature) {
        console.warn("Attempted to click signature button ToS on a non signature field, with fieldType: ".concat(fieldType));
        return;
      } // Autofill signature and return if conditions are met.


      if (_this.shouldAutosign(field)) {
        var fieldValue = isInitials ? initials : name;

        _this.onChangeFieldValue(documentId, fieldId, fieldValue);

        return;
      }

      _this.setState(function (_ref14) {
        var modals = _ref14.modals;
        return {
          modals: _objectSpread({}, modals, {
            signature: {
              open: true,
              field: field
            }
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentDocument", function () {
      // Return whatever document is currently chosen
      var _this$state3 = _this.state,
          currentDocumentId = _this$state3.currentDocumentId,
          documents = _this$state3.documents;
      return documents.find(function (_ref15) {
        var id = _ref15.id;
        return currentDocumentId === id;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "canViewDocument", function (documentId) {
      // Some documents will come from the API
      // with no images.  This means they do not get to view the document
      // But Product wants them to be able to see that the doc is part of the
      // offer package
      var documents = _this.state.documents;
      var doc = documents.find(function (_ref16) {
        var id = _ref16.id;
        return id === documentId;
      });
      return doc._derived.isViewable;
    });

    _defineProperty(_assertThisInitialized(_this), "getDocumentPosition", function () {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref17$filterOutCompl = _ref17.filterOutCompleted,
          filterOutCompleted = _ref17$filterOutCompl === void 0 ? false : _ref17$filterOutCompl;

      var _this$state4 = _this.state,
          currentDocumentId = _this$state4.currentDocumentId,
          documents = _this$state4.documents;
      var docs = documents.filter(function (_ref18) {
        var isViewable = _ref18._derived.isViewable;
        return isViewable;
      });

      if (filterOutCompleted) {
        docs = docs.filter(function (_ref19) {
          var id = _ref19.id,
              isComplete = _ref19._derived.isComplete;
          return id === currentDocumentId || !isComplete;
        });
      }

      var docIds = docs.map(function (_ref20) {
        var id = _ref20.id;
        return id;
      });
      var currDocIndex = docIds.indexOf(currentDocumentId);
      var prevDocId = docIds[currDocIndex - 1];
      var nextDocId = docIds[currDocIndex + 1];
      return {
        prevDocId: prevDocId,
        nextDocId: nextDocId
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setCurrentDocument", function (newDocumentId) {
      if (!_this.canViewDocument(newDocumentId)) return;
      var currentDocumentId = _this.state.currentDocumentId;
      if (newDocumentId === currentDocumentId) return; // If there is an autosave pending, flush it.

      _this.autosave.flush();

      _this.setState(function (_ref21) {
        var currentDocumentId = _ref21.currentDocumentId;
        return {
          currentDocumentId: newDocumentId,
          signedFieldTypes: {}
        };
      }, function () {
        return _this.setAcknowledgmentClosed(false);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleActionButtonClick", function (type) {
      // This function handles submit, cancel, and save buttons
      // We access the props based on the type of action button clicked
      // and then call that function and pass up the documents
      _this.setState({
        isPerformingAction: true
      });

      var _this$props$actions2 = _this.props.actions,
          actions = _this$props$actions2 === void 0 ? {} : _this$props$actions2;
      var documents = _this.state.documents;

      var _ref22 = actions || {},
          _ref22$type = _ref22[type],
          actionObject = _ref22$type === void 0 ? {} : _ref22$type;

      var _ref23 = actionObject || {},
          action = _ref23.action;

      if (typeof action !== 'function') {
        console.warn("Attempted to call action of type \"".concat(type, "\" from DocumentViewerContainer, but it was not passed in."));
        return;
      }

      return Promise.resolve(action(documents)).then(function () {
        return _this.setState({
          errors: []
        });
      }).catch(function () {
        var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var isDocError = false;

        if (Array.isArray(errors)) {
          isDocError = errors.some(function (_ref24) {
            var documentId = _ref24.documentId;
            return documentId;
          });
        }

        var growlType = isDocError ? 'documentError' : 'unknownError';

        _this.setState(function (_ref25) {
          var documents = _ref25.documents;
          return {
            documents: (0, _decorateDocuments.default)(documents, errors),
            errors: errors,
            growlType: growlType,
            growlOpen: true
          };
        }); // Re-throw errors so subsequent catch blocks attached to this promise
        // will trigger.


        return Promise.reject(errors);
      }).finally(function () {
        return _this.setState({
          isPerformingAction: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAcknowledgment", function () {
      var errors = _this.state.errors;

      _this.setState(function (_ref26) {
        var documents = _ref26.documents,
            currentDocumentId = _ref26.currentDocumentId;
        var newDocs = documents.map(function (doc) {
          return doc.id === currentDocumentId ? _objectSpread({}, doc, {
            crew_acknowledged: true
          }) : doc;
        });
        return {
          documents: (0, _decorateDocuments.default)(newDocs, errors)
        };
      }, _this.onDocumentDidChange);
    });

    _defineProperty(_assertThisInitialized(_this), "setFieldRef", function (ref, y, fieldId) {
      // Store the field ref in state
      var currentDocumentId = _this.state.currentDocumentId;
      _this["__".concat(currentDocumentId, "-").concat(fieldId)] = {
        ref: ref,
        y: y
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderFormField", function (field) {
      var fieldId = field.id,
          _field$_derived4 = field._derived,
          fieldType = _field$_derived4.fieldType,
          readOnlyTooltip = _field$_derived4.readOnlyTooltip;

      if (readOnlyTooltip) {
        var left = field.x,
            top = field.y,
            height = field.height,
            width = field.width;
        var style = {
          left: left,
          top: top,
          height: height,
          width: width,
          position: 'absolute'
        };
        return _react.default.createElement(_core.Tooltip, {
          title: readOnlyTooltip,
          enterDelay: 500,
          key: fieldId,
          placement: "bottom"
        }, _react.default.createElement("div", {
          style: style
        }));
      }

      var currentDocument = _this.getCurrentDocument();

      var documentId = currentDocument.id;

      var _assertThisInitialize = _assertThisInitialized(_this),
          handleSignatureButtonClick = _assertThisInitialize.handleSignatureButtonClick,
          onChangeFieldValue = _assertThisInitialize.onChangeFieldValue;

      var props = _objectSpread({}, field, {
        handleSignatureButtonClick: handleSignatureButtonClick,
        handleChange: function handleChange(newValue) {
          return onChangeFieldValue(documentId, fieldId, newValue);
        },
        setFieldRef: function setFieldRef(ref, y) {
          return _this.setFieldRef(ref, y, fieldId);
        }
      });

      var FormField = FieldStore[fieldType];

      if (!FormField) {
        var throwFatalError = _this.props.throwFatalError;
        throwFatalError('Unable to render Document Field');
        return;
      }

      return _react.default.createElement(FormField, _extends({}, props, {
        key: fieldId
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "goToField", function (fieldId) {
      var _this$getCurrentDocum3 = _this.getCurrentDocument(),
          _this$getCurrentDocum4 = _this$getCurrentDocum3.fields,
          fields = _this$getCurrentDocum4 === void 0 ? [] : _this$getCurrentDocum4,
          documentId = _this$getCurrentDocum3.id;

      var field = fields.find(function (_ref27) {
        var id = _ref27.id;
        return id === fieldId;
      });
      var page = field.page;

      _this.__documentViewer.setPage(null, page).then(function () {
        var _ref28 = _this["__".concat(documentId, "-").concat(fieldId)] || {},
            ref = _ref28.ref,
            _ref28$y = _ref28.y,
            y = _ref28$y === void 0 ? 0 : _ref28$y;

        if (!ref) return; // If the field is outside the viewport, scroll to bring it in

        var isInViewport = (0, _inViewport.default)(ref, {
          container: _this.__root
        });
        if (!isInViewport) _this.__documentViewer.scrollTo(y * 0.8); // Focus the field

        var _field$_derived5 = field._derived,
            fieldType = _field$_derived5.fieldType,
            isSignature = _field$_derived5.isSignature; // If field is a signature, simulate a click on the signature button
        // UNLESS clicking the button would autofill the signature.

        if (isSignature) {
          if (!_this.shouldAutosign(field)) {
            _this.handleSignatureButtonClick(fieldId);
          }

          return;
        } // If field is a date, open the datepicker.


        if (fieldType === FieldTypes.DATE) {
          ref.setOpen(true);
          return;
        } // Otherwise just try and focus the field


        ref.focus && ref.focus();
        ref.node && ref.node.focus && ref.node.focus();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setIsSignatureSaved", function (isSignatureSaved) {
      return _this.setState({
        isSignatureSaved: isSignatureSaved
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setRootRef", function (root) {
      return _this.__root = root;
    });

    _defineProperty(_assertThisInitialized(_this), "setDocumentViewerRef", function (documentViewer) {
      return _this.__documentViewer = documentViewer;
    });

    var _this$props = _this.props,
        _documents = _this$props.documents,
        _throwFatalError = _this$props.throwFatalError;

    if (!(_documents && _documents.length)) {
      _throwFatalError('No Documents passed down');

      return _possibleConstructorReturn(_this);
    }

    var decoratedDocs = (0, _decorateDocuments.default)(_documents); // Get first viewable document

    var firstViewableDoc = decoratedDocs.find(function (doc) {
      return doc._derived.isViewable;
    }) || {};
    var firstViewableDocId = firstViewableDoc.id;

    if (!firstViewableDocId) {
      _throwFatalError('No Documents found with images');

      return _possibleConstructorReturn(_this);
    }

    _this.state = {
      documents: decoratedDocs,
      currentDocumentId: firstViewableDocId,
      modals: {
        signature: {
          open: false,
          field: null
        },
        acknowledgment: {
          closed: false
        }
      },
      growlType: null,
      growlOpen: false,
      signedFieldTypes: {},
      isPerformingAction: false,
      isSignatureSaved: false,
      errors: []
    };
    return _this;
  }

  _createClass(DocumentSigner, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          actions = _this$props2.actions,
          actor = _this$props2.actor,
          classes = _this$props2.classes,
          getDocumentImageUrls = _this$props2.getDocumentImageUrls,
          me = _this$props2.me,
          throwFatalError = _this$props2.throwFatalError,
          templatesAcknowledgeNotes = _this$props2.templatesAcknowledgeNotes,
          templatesAcknowledgeTitle = _this$props2.templatesAcknowledgeTitle,
          className = _this$props2.className,
          isSaveSignatureEnabled = _this$props2.isSaveSignatureEnabled;
      var _this$state5 = this.state,
          documents = _this$state5.documents,
          growlType = _this$state5.growlType,
          growlOpen = _this$state5.growlOpen,
          isPerformingAction = _this$state5.isPerformingAction,
          modals = _this$state5.modals;

      var _ref29 = modals || {},
          _ref29$signature = _ref29.signature,
          signatureModalConfig = _ref29$signature === void 0 ? {} : _ref29$signature;

      var _ref30 = modals || {},
          _ref30$acknowledgment = _ref30.acknowledgment;

      _ref30$acknowledgment = _ref30$acknowledgment === void 0 ? {} : _ref30$acknowledgment;
      var acknowledgmentClosed = _ref30$acknowledgment.closed;
      var currentDocument = this.getCurrentDocument();
      var acknowledgeTitle = currentDocument.acknowledge_title,
          acknowledgeNotes = currentDocument.acknowledge_notes,
          acknowledgeType = currentDocument.acknowledge_type,
          crewAcknowledged = currentDocument.crew_acknowledged;
      var showClickThroughAcknowledgment = acknowledgeType === 'C' && !crewAcknowledged && !acknowledgmentClosed;

      var _this$getDocumentPosi2 = this.getDocumentPosition(),
          prevDocId = _this$getDocumentPosi2.prevDocId,
          nextDocId = _this$getDocumentPosi2.nextDocId;

      var _this$getDocumentPosi3 = this.getDocumentPosition({
        filterOutCompleted: true
      }),
          nextIncompleteDocId = _this$getDocumentPosi3.nextDocId;

      var isOfferComplete = documents.every(function (_ref31) {
        var isComplete = _ref31._derived.isComplete;
        return isComplete;
      });
      var groupedAcknowledgmentDocumentNames = documents.filter(function (doc) {
        return doc.acknowledge_type === 'G';
      }).map(function (doc) {
        return doc.templateName;
      });
      return _react.default.createElement(_core.MuiThemeProvider, {
        theme: _theme.documentSignerTheme
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        ref: this.setRootRef
      }, isPerformingAction && _react.default.createElement("div", {
        className: classes.busyOverlay,
        "data-test-id": "DocumentSigner-busyOverlay"
      }, _react.default.createElement("div", {
        className: classes.busyContainer
      }, _react.default.createElement(_core.CircularProgress, {
        color: "black"
      }), _react.default.createElement(_core.Typography, null, "Processing..."))), _react.default.createElement(_DocumentSelector.default, {
        className: classes.documentSelector,
        documents: documents,
        setCurrentDocument: this.setCurrentDocument,
        goToField: this.goToField,
        currentDocumentId: currentDocument.id,
        onSelectAcknowledgment: function onSelectAcknowledgment() {
          return _this2.setAcknowledgmentClosed(false);
        }
      }), _react.default.createElement(_DocumentViewer.default, {
        className: classes.documentViewer,
        currentDocument: currentDocument,
        getDocumentImageUrls: getDocumentImageUrls,
        throwFatalError: throwFatalError,
        setCurrentDocument: this.setCurrentDocument,
        prevDocId: prevDocId,
        nextDocId: nextDocId,
        renderField: this.renderFormField,
        innerRef: this.setDocumentViewerRef,
        actionButtons: _react.default.createElement(_ActionButtons.default, {
          actions: actions,
          actionButtonClick: this.handleActionButtonClick,
          isOfferComplete: isOfferComplete,
          groupedAcknowledgmentDocumentNames: groupedAcknowledgmentDocumentNames,
          templatesAcknowledgeNotes: templatesAcknowledgeNotes,
          templatesAcknowledgeTitle: templatesAcknowledgeTitle
        })
      }), _react.default.createElement(_SignatureTOSDialog.default, {
        config: signatureModalConfig,
        actor: actor,
        handleSubmit: this.acceptSignatureTOS,
        handleClose: this.closeSignatureTOSDialog
      }), _react.default.createElement(_ClickThroughAcknowledgment.default, {
        isOpen: showClickThroughAcknowledgment,
        title: acknowledgeTitle,
        description: acknowledgeNotes,
        onAcknowledge: this.handleAcknowledgment,
        onClose: function onClose() {
          return _this2.setAcknowledgmentClosed(true);
        }
      }), _react.default.createElement(_GrowlNotification.default, {
        isOpen: growlOpen,
        onClose: this.hideNotification,
        onExited: this.cleanUpNotification,
        onContinue: this.handleNotificationContinue(nextIncompleteDocId),
        type: growlType
      }), isSaveSignatureEnabled && _react.default.createElement(_SaveSignature.default, {
        actor: actor,
        onSaveSignature: this.setIsSignatureSaved,
        documents: documents,
        me: me
      })));
    }
  }]);

  return DocumentSigner;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(DocumentSigner);

exports.default = _default;